import { AlertWindow } from '@sunwebgroup/ui-components/uds'
import { useRouter } from 'next/navigation'
import * as React from 'react'
import { useIntl } from 'react-intl'

export function DeleteAccountSuccessModal() {
  const intl = useIntl()
  const router = useRouter()

  const handleClose = () => {
    router.push('/')
  }

  return (
    <AlertWindow.Root open onOpenChange={handleClose}>
      <AlertWindow.Content
        text={intl.formatMessage({ id: 'user_profile_delete_success_title' })}
        primaryButtonText={intl.formatMessage({ id: 'user_profile_delete_success_dismiss' })}
        onPrimaryAction={handleClose}
      />
    </AlertWindow.Root>
  )
}
